import * as z from "zod";

export const setupContextualDomain = {
  name: "setupContextualDomain" as const,
  input: z.object({ domain: z.string() }),
  output: z.object({ hostnameId: z.string() }),
};
